/**
 * This component renders an overview for a single game
 * @param {object} gameData - Data about the game
 */
import React from "react";
import { Link } from "react-router-dom";
import { formatFaceoffTimeDate } from "../utils/time.js";

const GameOverview = ({ gameData, index }) => {

  // console.log("GameOverview data:", gameData);

  const blip = {
    backgroundColor: `#${gameData.blip_color}`,
  };


  return (
    <div className={`border-0 border-t-2 dark:border-dark-3 border-light-3 md:h-[150px] w-full flex flex-col md:flex-row max-md:items-center justify-center 
      md:justify-between md:pt-3 py-2 xs:py-2 sm:py-3 sm:py-4 sm:px-3 
      bg-light-1 dark:bg-dark-1 ${index % 2 === 1 ? 'bg-light-4 dark:bg-dark-4' : ''}`}>
      {/* Game Info */}
      <div
        className={`flex flex-col max-md:mb-1 xl:w-40 xl:max-w-40 ${
          gameData.blip_text !== undefined
            ? "justify-between md:mt-1"
            : "justify-center"
        }`}
      >
        <>
          {/* Home/Away */}
          {gameData.blip_text !== undefined ? (
            <span
              className="max-md:hidden dark:text-black text-white dark:bg-dark-5 p-1 px-2 rounded w-16"
              style={blip}
            >
              <span className="blip-text">{gameData.blip_text}</span>
            </span>
          ) : null}
        </>

        {/* Date and location */}
        <div
          className={`flex max-sm:text-xxs flex-col items-center md:justify-start md:items-start justify-center`}
        >
          {/* Competition */}
          <Link to={`/division/${gameData.division.id}`}>
          <p className="leading-tight md:mb-2 max-md:text-center max-xs:text-xs text-xsm flex-wrap w-36 hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-normal">
            {gameData.division.blip} 
          </p>
          </Link>
          <div className="flex flex-row items-center justify-center md:justify-start md:flex-col md:items-start leading-tight">
            <p className="max-md:text-xxs text-xs  text-darken font-light">
              {/*{formatFaceoffTimeDate(new Date(gameData.date))}*/}
              {gameData.date_text} {gameData.time_text}
            </p>
            <p className="md:hidden max-md:text-xxs text-darken flex mx-2">-</p>
            <p className="text-xs text-darken flex-wrap font-light">
              {gameData.full_location}
            </p>
            <p className="max-md:text-xxs text-darken pl-1 max-xs:hidden md:hidden">
              {`(${gameData.blip_text})`}
            </p>
          </div>
        </div>
      </div>

      {/* Team info */}
      <div className="max-xs:mt-0.5 max-md:mt-2 flex flex-row">
        {/* Home team info */}
        <Link
          to={`/club/${gameData.home_team.club}`}
          className="flex flex-col w-28 xxs:w-36 xs:w-56 sm:w-72 md:w-60 items-center justify-center group"
        >
          <img
            className="sm:w-20 sm:h-20 xxs:h-16 xxs:w-16 h-14 w-14 mb-1"
            src={gameData.home_team.logo.lg}
            alt={gameData.home_team.name}
          />
          <p className="leading-tight px-1 xs:px-2 max-xxs:text-xxs xxs:max-sm:text-xs text-center group-hover:dark:text-dark-5 group-hover:text-buiha-red ease-in-out duration-200 leading-tightuiha-red ease-in-out duration-200">
            {gameData.home_team.name}
          </p>
        </Link>
        {/* VS or more info */}
        <div className="flex flex-col items-center justify-center max-xxs:mx-1 xxs:max-x450:mx-2 x450:max-md:mx-4">
          {gameData.played === 1 || gameData.played === 3 ? (
            <p className="flex px-2 text-2xl font-bold w-20 xs:w-24 items-center justify-center max-md:pb-2">
              {gameData.home_score}-{gameData.away_score}
            </p>
          ) : gameData.played === 0 ? (
            <p className="flex sm:hidden md:flex px-2">
              <p className="flex px-2 text-xl xs:w-24 items-center justify-center max-md:pb-2">
              vs
            </p>
            </p>
          ) : (
            <p className="flex sm:hidden md:flex px-2">
              <p className="flex px-2 text-smm xs:w-24 items-center justify-center max-md:pb-2">
              {gameData.played_status}
            </p>
            </p>
          )}

          <div className="flex md:hidden flex-col items-center justify-center">
            <Link to={`/game/${gameData.id}`}>
              <button className="max-xxs:text-xxs xxs:max-sm:text-xs border-buiha-red dark:border-dark-5 p-1 sm:p-2 sm:px-3 xs:px-2 xs:p-1 rounded border-2 hover:bg-buiha-red dark:hover:bg-dark-5 hover:text-white duration-200 ease-in-out">
                Details
              </button>
            </Link>
          </div>
        </div>
        {/* Away team info */}
        <Link
          to={
            gameData.away_team.club === 0
              ? ""
              : `/club/${gameData.away_team.club}`
          }
          className={`flex flex-col w-28 xxs:w-36 xs:w-56 sm:w-72 md:w-60 items-center justify-center ${
            gameData.away_team.club === 0 ? "" : "group"
          }`}
          onClick={(e) => {
            if (gameData.away_team.club === 0) e.preventDefault(); // Prevent navigation if club is 0
          }}
        >
          <img
            className="sm:w-20 sm:h-20 xxs:h-16 xxs:w-16 h-14 w-14 mb-1"
            src={gameData.away_team.logo.lg}
            alt={gameData.away_team.name}
          />
          <p className="leading-tight px-1 xs:px-2 max-xxs:text-xxs xxs:max-sm:text-xs text-center group-hover:dark:text-dark-5 group-hover:text-buiha-red ease-in-out duration-200 leading-tightuiha-red ease-in-out duration-200">
            {gameData.away_team.name}
          </p>
        </Link>
      </div>

      {/* More info */}

      <div className="hidden md:flex max-xs:mt-2 flex flex-col items-center justify-center">
        <Link to={`/game/${gameData.id}`}>
          <button className="max-xs:text-xs border-buiha-red dark:border-dark-5 p-1 xs:p-2 xs:px-3 mr-1 rounded font-light border-2 hover:bg-buiha-red dark:hover:bg-dark-5 hover:text-white duration-200 ease-in-out">
            Details
          </button>
        </Link>
      </div>
    </div>
  );
};
export default GameOverview;
